import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/auth-guard/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'core',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./view/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'core',
    loadChildren: () =>
      import('./view/core/core.module').then((m) => m.CorePageModule),
    canLoad: [AuthGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
